import React, { useContext, useEffect, useState } from 'react'
import HeroSection from '../components/HeroSection'
import Developers from '../components/Developers'
import Properties from '../components/Properties'
import Communities from '../components/Communities'
import Footer from '../components/Footer'
import ExploreMap from '../components/ExploreMap'
import { GlobalContext } from '../GlobalContext';
import { getallPropertiesFilterApi, getCommunityList, getProjectNames, getPropertyListNew } from '../services/Api'
import SearchFilter from '../components/SearchFilter'
import StaticProperties from '../components/StaticProperties'
import { useTranslation } from 'react-i18next';

const sampleData = [

]






const MainPage = () => {
  const { t, i18n } = useTranslation();
  const BATCH_SIZE = 12;
  const [isLoading, setIsLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);

  const { selectedLocation, getProperty,setDeveloper, propertyCategory, setPropertyCategory, activeFilter, setActiveFilter, selectedCategory, setSelectedCategory, activeFilters, setGetProperty, page, setPage, globalVar, type, budget, handover, locationSelect, developer, project, keywords , setProject} = useContext(GlobalContext);
  const [firstData, setFirstData] = useState([]);
  const [filterTriggered, setFilterTriggered] = useState(false)
  const [nextPage, setNextPage] = useState(1);
  const [projectOptions, setProjectOptions] = useState([]);
  const [communityOptions, setCommunityOptions] = useState([]);
  const [roomOptions, setRoomOptions] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [salesStatusOptions, setSalesStatusOptions] = useState([]);
  const [projectStatusOptions, setProjectStatusOptions] = useState([]);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [amenityOptions, setAmenityOptions] = useState([]);
  const [developerOptions, setDeveloperOptions] = useState([]);

  const [projectStatus, setProjectStatus] = useState([]);
  const [community, setCommunity] = useState([]);
  const [salesStatus, setSalesStatus] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [unitType, setUnitType] = useState([]);
  const [newUnitType, setNewUnitType] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [facility, setFacility] = useState([]);
  const [rentalGuarantee, setRentalGuarantee] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [deliveryPlan, setDeliveryPlan] = useState([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [minArea, setMinArea] = useState(0);
  const [maxArea, setMaxArea] = useState(0);
  const [downPayment, setDownPayment] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');

  const [countMessage, setCountMessage] = useState(''); 
const [loadingCountMessage, setLoadingCountMessage] = useState(true);

  useEffect(() => {
    getProjectNamesData();

  }, [selectedCategory, activeFilters]);
  const handleRest = () => {
      console.log('Resetting form states');
        setProjectStatus([]);
        setDeveloper(null);
        setProject([]);
        setSalesStatus([]);
        setProjectType([]);
        setUnitType('');
        setRooms([]);
        setFacility([]);
        setCommunity([]);
        setRentalGuarantee([]);
        setPaymentPlan([]);
        setDeliveryPlan([]);
        setMinPrice(0);
        setMaxPrice(0);
        setMinArea(0);
        setMaxArea(0);
        setDownPayment('');
        setDeliveryDate([]);
        setNewUnitType([]);
        // setSearchTrigger(true);
    }
const getPropertyData = async (currentPage, sortBy = 'latest', reset = false) => {
  try {
    setIsLoading(true);
    setLoadingCountMessage(true);  // Show loading message for the count
    setCountMessage('Loading properties...');  // Show loading message initially

    let categoryParam = '';
    if ((propertyCategory === 'ready_to_move') || (projectStatus?.label === 'Ready')) {
      categoryParam = 2;
    } else if ((propertyCategory === 'off_plan') || (projectStatus?.label === 'Off Plan')) {
      categoryParam = 1;
    } else if (propertyCategory === 'all') {
      categoryParam = 0;
    }

    const unitTypeFilterValue = type && type !== "Any Type" ? type : null;
const unitTypeLabel = type && type !== "Any Type" ? type : t("project", { defaultValue: "project" }); // fallback





    

    const response = await getPropertyListNew(
      currentPage,
      BATCH_SIZE,
      sortBy,
      categoryParam,
      activeFilters?.type || null,
      activeFilters?.budget || null,
      activeFilters?.handover || null,
      activeFilters?.location || null,
      activeFilters?.developer || null,
      activeFilters?.project || null,
      activeFilters?.keywords || null,
      selectedLocation,
      salesStatus?.label || null,
      projectType?.label || null,
      unitTypeFilterValue,
      rooms?.label || null,
      facility?.label || null,
      community?.label || null,
      rentalGuarantee?.value || null,
      paymentPlan?.value || null,
      deliveryPlan?.value || null,
      minArea,
      maxArea,
      minPrice,
      maxPrice,
      downPayment,
      deliveryDate?.value || null
    );

    if (response?.results?.success) {
      const newProperties = response.results.data;
      setNextPage(response.next ? response.next : null);

      // Update properties only after successfully fetching data
      setGetProperty((prevProperties) =>
        reset ? newProperties : [...prevProperties, ...newProperties]
      );

      const totalCount = response.count;

setCountMessage(
  totalCount === 0
    ? t("property.noResults", { type: unitTypeLabel })
    : t("property.foundResults", { count: totalCount, type: unitTypeLabel })
);



      setHasNextPage(!!response.results.next);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoading(false);  // Reset loading state
    setLoadingCountMessage(false);  // Hide loading state for the count message
  }
};


    const handleLoadMore = () => {
    if (!isLoading && nextPage) {
      getPropertyData(nextPage, false); // Load next set of properties
    }
  };

  
  useEffect(() => {
    getPropertyData(1, true); // Load initial data when component mounts or category changes
  }, [selectedLocation, propertyCategory, activeFilters]);

  console.log('getPropertyData', getProperty);
  // useEffect(() => {
  //   getPropertyData();
  // }, [propertyCategory, selectedLocation]);

  console.log('selectedLocation', selectedLocation);

  const onPageChange = (newPage) => {
    const isReset = newPage === 1;
    setPage(newPage);
    getPropertyData(newPage, 'latest', isReset);
  };

  // When category changes (e.g., "Off Plan", "Ready to Move")
  // useEffect(() => {
  //     setPage(1);
  //     setGetProperty([]);
  //     setFilterTriggered(true); // Mark that user is interacting
  //     getPropertyData(1, 'latest', true); // Fetch fresh based on category
  // }, [selectedCategory]);

  // When filters are triggered (controlled by SearchFilter)
  useEffect(() => {
    if (activeFilter && Object.keys(activeFilters).length > 0) {
      setPage(1);
      setGetProperty([]); // Clear previous data
      getPropertyData(1, 'latest', true); // Fetch filtered data
    }
  }, [activeFilters]);

  useEffect(() => {
    getProjectNamesData();
    getCommunityNamesData();
    getAllFilterData();
  }, []);

  // console.log('communityOptions', communityOptions)

  const getProjectNamesData = async () => {
    const response = await getProjectNames();
    if (response?.success) {
      const projectOptions = response.data.map((item) => ({
        label: item.title,
        id: item.id
      }));
      setProjectOptions(projectOptions);
      console.log('projectOptions', projectOptions)
    } else {
      console.error("Failed to fetch project names");
    }
  };

  const getCommunityNamesData = async () => {
    const response = await getCommunityList();
    if (response?.success) {
      const communityOptions = response.data.map((item) => ({
        label: item.name,
        id: item.id
      }));

      const uniqueCommunityOptions = communityOptions.filter((option, index) => {
        return communityOptions.findIndex(o => o.id === option.id) === index;
      })
      setCommunityOptions(uniqueCommunityOptions);
    } else {
      console.error("Failed to fetch community names");
    }
  }

  const getAllFilterData = async () => {
    try {
      const response = await getallPropertiesFilterApi();
      if (response?.success) {
        const {
          project_name: projectNames = [],
          rooms = [],
          unit_type = [],
          sales_status = [],
          community = [],
          developer = [],
          project_status = [],
          project_type = [],
          amenity = [],
        } = response.data;

        // map each list into whatever shape your selects need:
        //   setProjectOptions(
        //     projectNames.map((title) => ({ label: title, value: title }))
        //   );
        setRoomOptions(
          rooms.map((r) => ({ label: String(r), value: r }))
        );
        setUnitTypeOptions(
          unit_type.map((ut) => ({ label: ut, value: ut }))
        );
        setSalesStatusOptions(
          sales_status.map((s) => ({ label: s, value: s }))
        );
        //   setCommunityOptions(
        //     community.map((c) => ({ label: c, value: c }))
        //   );
        setDeveloperOptions(
          developer.map((d) => ({ label: d, value: d }))
        );
        setProjectStatusOptions(
          project_status.map((ps) => ({ label: ps, value: ps }))
        );
        setProjectTypeOptions(
          project_type.map((pt) => ({ label: pt, value: pt }))
        );
        setAmenityOptions(
          amenity.map((a) => ({ label: a, value: a }))
        );
      } else {
        console.error("Failed to fetch filter data:", response.error);
      }
    } catch (err) {
      console.error("Error calling filter API:", err);
    }
  };


  const [initialProperties, setInitialProperties] = useState([]);
  const [initialLoading, setInitialLoading] = useState(false);



  useEffect(() => {
    const fetchInitialProperties = async () => {
      try {
        setInitialLoading(true);
        const response = await getPropertyListNew(
          1, // page
          8, // show 8 featured items
          'latest', // sort order
          0, // category = all
          '', '', '', '', '', '', '', ''
        );
        if (response?.results?.success) {
          setInitialProperties(response.results.data);
        }
      } catch (error) {
        console.error("Error loading featured properties:", error);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchInitialProperties();
  }, []);


  return (
    <div className="min-h-screen">
      <HeroSection
        getPropertyData={getPropertyData}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        projectOptions={projectOptions}
        communityOptions={communityOptions}
      />
      <StaticProperties
      />

      <Communities />
      {/* <Developers /> */}
      <SearchFilter
        getPropertyData={getPropertyData}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        projectOptions={projectOptions}
        communityOptions={communityOptions}
        roomOptions={roomOptions}
        unitTypeOptions={unitTypeOptions}
        salesStatusOptions={salesStatusOptions}
        projectStatusOptions={projectStatusOptions}
        projectTypeOptions={projectTypeOptions}
        developerOptions={developerOptions}
        amenityOptions={amenityOptions}
        initialProperties={initialProperties}
        initialLoading={initialLoading}
        setProjectStatus={setProjectStatus}
        projectStatus={projectStatus}
        setSalesStatus={setSalesStatus}
        salesStatus={salesStatus}
        setProjectType={setProjectType}
        projectType={projectType}
        setUnitType={setUnitType}
        unitType={unitType}
        setRooms={setRooms}
        rooms={rooms}
        setFacility={setFacility}
        facility={facility}
        setCommunity={setCommunity}
        community={community}
        setRentalGuarantee={setRentalGuarantee}
        rentalGuarantee={rentalGuarantee}
        setPaymentPlan={setPaymentPlan}
        paymentPlan={paymentPlan}
        setDeliveryPlan={setDeliveryPlan}
        deliveryPlan={deliveryPlan}
        setMinPrice={setMinPrice}
        minPrice={minPrice}
        setMaxPrice={setMaxPrice}
        maxPrice={maxPrice}
        setMinArea={setMinArea}
        minArea={minArea}
        setMaxArea={setMaxArea}
        maxArea={maxArea}
        setDownPayment={setDownPayment}
        downPayment={downPayment}
        setDeliveryDate={setDeliveryDate}
        deliveryDate={deliveryDate}
        handleRest={handleRest}

        setNewUnitType={setNewUnitType}
        newUnitType={newUnitType}
      />
      {activeFilter && (
        <Properties
          largePadding
          getPropertyData={getPropertyData}
          isLoading={isLoading}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          onPageChange={onPageChange}
          nextPage={nextPage}

          handleLoadMore={handleLoadMore}

          countMessage={countMessage}

        />
      )}
      <Footer />
    </div>
  );
};


export default MainPage